import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import MenuPage from './pages/Menu/MenuPage';
import Navbar from './pages/Navbar/Navbar';
import AdminLogin from './pages/Admin/Login/Admin';
import AdminActions from './pages/Admin/Actions/AdminActions';
import GaleriPage from './pages/Galeri/GaleriPage';
import HakkimizdaPage from './pages/Hakkımızda/HakkimizdaPage';
import ContactPage from './pages/Contact/ContactPage';

function App() {
  return (
    <Router>
      <div>
        <Navbar />
        <Routes>
          <Route path="/" element={<MenuPage />} />
          <Route path="/Admin/Login" element={<AdminLogin />} />
          <Route path="/Admin/Actions" element={<AdminActions />} />
          <Route path="/Menu" element={<MenuPage />} />
          <Route path="/Galeri" element={<GaleriPage />} />
          <Route path="/Hakkimizda" element={<HakkimizdaPage />} />
          <Route path="/iletisim" element={<ContactPage />} />
          {/* Add more routes as needed */}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
